import { z } from "zod"

export const RoleSchema = z.object({
  name: z.string(),
  description: z.string().nullable(),
  rule_name: z.string().nullable(),
  data: z.unknown().nullable(),
  permission_count: z.number(),
  user_count: z.number(),
  created_at: z.string().nullable(),
  updated_at: z.string().nullable(),
})

export const RoleDetailSchema = z.object({
  name: z.string(),
  description: z.string().nullable(),
  rule_name: z.string().nullable(),
  data: z.unknown().nullable(),
  created_at: z.string().nullable(),
  updated_at: z.string().nullable(),
  permissions: z.object({
    assigned: z.array(z.string()),
    available: z.array(z.string()),
  }),
  user_count: z.number(),
  child_roles: z.array(z.string()),
})

export const PermissionSchema = z.object({
  name: z.string(),
  description: z.string().nullable(),
  rule_name: z.string().nullable(),
  used_by: z.array(z.string()),
  created_at: z.string().nullable(),
  updated_at: z.string().nullable(),
})

export const PermissionTreeNodeSchema: z.ZodType<PermissionTreeNode> = z.lazy(() =>
  z.object({
    name: z.string(),
    description: z.string().nullable(),
    rule_name: z.string().nullable(),
    used_by: z.array(z.string()),
    children: z.array(PermissionTreeNodeSchema).optional(),
    created_at: z.string().nullable().optional(),
    updated_at: z.string().nullable().optional(),
  }),
)

export const PermissionsListSchema = z.object({
  items: z.array(PermissionTreeNodeSchema),
  flat: z.array(PermissionSchema),
})

export const RoleFormSchema = z.object({
  name: z.string().min(1, "adminRoles.validation.nameRequired"),
  description: z.string().optional().default(""),
  rule_name: z.string().nullable().optional().default(null),
})

export const RoleUserSchema = z.object({
  id: z.number(),
  username: z.string(),
  full_name: z.string(),
  email: z.string(),
  status: z.number(),
  agency_name: z.string().nullable(),
})

export type Role = z.infer<typeof RoleSchema>
export type RoleDetail = z.infer<typeof RoleDetailSchema>
export type Permission = z.infer<typeof PermissionSchema>
export type PermissionTreeNode = {
  name: string
  description: string | null
  rule_name: string | null
  used_by: string[]
  children?: PermissionTreeNode[]
  created_at?: string | null
  updated_at?: string | null
}
export type PermissionsList = z.infer<typeof PermissionsListSchema>
export type RoleFormValues = z.infer<typeof RoleFormSchema>
export type RoleUser = z.infer<typeof RoleUserSchema>
